import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
import { getAnchorName, buildSubtypeSubsegmentLink } from 'site-modules/shared/utils/upper-funnel/type-rankings';
import { ScrollElement } from 'site-modules/shared/components/scroll-link/scroll-element';
import { LazyContentCollapseTransitioned } from 'site-modules/shared/components/lazy-content-collapse/lazy-content-collapse-transitioned';
import { RankingsVehicleCard } from 'site-modules/upper-funnel/components/type/rankings-vehicle-card/rankings-vehicle-card';
import { TypeRankingsEntities } from 'client/data/models/type-rankings-entities';
import { RANKING_DATA } from 'site-modules/upper-funnel/constants/ranking-data';
import { VEHICLES_NUM_TO_RANK } from 'site-modules/shared/constants/upper-funnel/type-rankings';
import { MrectNative } from 'site-modules/shared/components/native-ad/mrect/mrect-native';
import { getSubtypeAds } from 'site-modules/upper-funnel/pages/subtype/get-subtype-ads';
// eslint-disable-next-line venom/no-internal-modules
import { EDSButton } from 'site-modules/edmunds-design-system/components/eds-button/eds-button';

import { ReadMore } from 'site-modules/upper-funnel/components/type/read-more/read-more';
import { SUV_EXTRA_HEADING_DATA } from 'site-modules/upper-funnel/components/type/vehicle-subtype-rankings-list/ads-11602-suv-read-more-data';
import { FilmstripTypeRankingFeatured } from 'site-modules/shared/components/native-ad/filmstrip-type-ranking/filmstrip-type-ranking-featured';

import './vehicle-subtype-rankings-list.scss';

export const getSubtypeAdPos = (index, isMobile, trkParam) => {
  switch (index) {
    case 3:
      return getSubtypeAds(trkParam, isMobile, true).pos1;
    case 6:
      return getSubtypeAds(trkParam, isMobile, true).pos2;
    case 9:
      return getSubtypeAds(trkParam, isMobile, true).segmentListing;
    case 15:
      return getSubtypeAds(trkParam, isMobile, true).filmstrip;
    case 18:
      return getSubtypeAds(trkParam, isMobile, true).pos3;
    case 21:
      return getSubtypeAds(trkParam, isMobile, true).pos4;
    default:
      return null;
  }
};

export const getSubtypeAdPosAds12491 = (index, isMobile, trkParam, ads12491Recipe) => {
  switch (index) {
    case 3:
      if (ads12491Recipe === 'chal1') {
        return getSubtypeAds(trkParam, isMobile, true).segmentListingAds12491Chal1;
      }
      if (ads12491Recipe === 'chal2') {
        return getSubtypeAds(trkParam, isMobile, true).segmentListingAds12491Chal2;
      }
      return getSubtypeAds(trkParam, isMobile, true).segmentListing;
    case 6:
      return getSubtypeAds(trkParam, isMobile, true).pos1;
    case 9:
      return getSubtypeAds(trkParam, isMobile, true).pos2;
    case 15:
      return getSubtypeAds(trkParam, isMobile, true).filmstrip;
    case 18:
      return getSubtypeAds(trkParam, isMobile, true).pos3;
    case 21:
      return getSubtypeAds(trkParam, isMobile, true).pos4;
    default:
      return null;
  }
};

export const getAdUnit = (idx, trkParam, isAds12484Enabled, isMobile) => {
  const mrectPos = idx + 1;
  if (isAds12484Enabled) {
    switch (idx) {
      case 0: // segment ad
        return (
          <FilmstripTypeRankingFeatured
            mobile={isMobile}
            wrapperClass=""
            cardClass="ranking-vehicle-card is-ads12484-enabled"
            position={'0'}
            isAds12484Enabled={isAds12484Enabled}
          />
        );
      case 1: // mrect pos 1
      case 2: // mrect pos 2
      case 3: // mrect pos 3
      case 4: // mrect pos 4
        return (
          <MrectNative
            position={`${idx}`}
            refreshable={false}
            customTargeting={trkParam}
            useMinHeight
            renderWhenViewable
            verticalOffset="100%"
          />
        );
      default:
        return null;
    }
  }
  switch (idx) {
    case 0: // mrect pos 1
    case 1: // mrect pos 2
    case 2: // mrect pos 3
    case 3: // mrect pos 4
      return (
        <MrectNative
          position={`${mrectPos}`}
          refreshable={false}
          customTargeting={trkParam}
          useMinHeight
          renderWhenViewable
          verticalOffset="100%"
        />
      );
    default:
      return null;
  }
};

const getRatedVehicleCardsList = ({
  segmentRatings,
  startPos,
  endPos,
  subtypeId,
  isEvData,
  isRatedList,
  index,
  renderSeeAllBtn,
  onSelectCar,
  selectedCars,
  isCollapseItem,
  isSubtypePage,
  subtypeAdPlacementIndices,
  isMobile,
  trkParam,
  skipRenderAds,
  type,
  isSubtypeExpansionPage,
  isSingleCategory = false,
  dataTrackingParent,
  isAds12484Enabled,
  ads12491Recipe,
}) => {
  const showRank = segmentRatings.length >= VEHICLES_NUM_TO_RANK;
  const slicedRatings = segmentRatings.slice(startPos, endPos);
  const indexToUse = isCollapseItem ? 0 : 1;
  const largeCards = [];
  const noSeeAllBtnNoAds = !renderSeeAllBtn && skipRenderAds;
  const isAds12484MrectStyle =
    isAds12484Enabled && index === 0
      ? { width: isMobile ? 'auto' : 'calc(33.33% - 16px)', height: 'auto' }
      : { width: '300px', height: '268px' };

  const isAds12491Enabled = ['chal1', 'chal2'].includes(ads12491Recipe);

  const smallCards = slicedRatings.reduce((acc, segmentRating, i) => {
    const { rank, baseStyleId } = segmentRating;
    const subtypeAbsoluteIndex = subtypeAdPlacementIndices && subtypeAdPlacementIndices[index].startIndex + i + 1;
    if (rank === 1 || isSubtypePage) {
      largeCards.push(
        <div key={`${baseStyleId}-${subtypeId}`} className="mb-1">
          <RankingsVehicleCard
            showRank={showRank}
            showEvData={isEvData}
            vehicle={segmentRating}
            onSelectCar={onSelectCar}
            selected={!!selectedCars.find(({ id: carId }) => carId === baseStyleId)}
            selectedCarsNumber={selectedCars.length}
            subtypeId={parseInt(subtypeId, 10)}
            isLargeCard
            isRatedList={isRatedList}
            isSubtypePage={isSubtypePage}
            isReplaceImage
            type={type}
            isMobile={isMobile}
            isSubtypeExpansionPage={isSubtypeExpansionPage}
            dataTrackingParent={dataTrackingParent}
          />
          {isAds12491Enabled
            ? getSubtypeAdPosAds12491(subtypeAbsoluteIndex, isMobile, trkParam, ads12491Recipe)
            : getSubtypeAdPos(subtypeAbsoluteIndex, isMobile, trkParam)}
        </div>
      );
    } else {
      acc.push(
        <Col
          xs={12}
          sm={6}
          lg={4}
          key={`${baseStyleId}-${subtypeId}`}
          className={classnames('d-md-inline-block align-top ps-md-0 mx-auto mx-sm-0', {
            'pe-md-1 mb-1': i === (indexToUse || isSingleCategory) && !noSeeAllBtnNoAds,
            'pe-lg-0 mb-1': isSingleCategory && i > 1 && !noSeeAllBtnNoAds,
            'pe-md-0 mb-1': i > indexToUse && !isSingleCategory && !noSeeAllBtnNoAds,
            'no-see-all-btn-no-ads': noSeeAllBtnNoAds,
            'mb-1': noSeeAllBtnNoAds && index === 0,
            'pe-md-1': noSeeAllBtnNoAds && i % 3 === 0 && i < 2,
            'pe-md-0 pe-lg-1': noSeeAllBtnNoAds && i % 3 === 0 && i > 1,
            'pe-md-0': noSeeAllBtnNoAds && i % 3 > 0 && i < 2,
            'pe-md-0 pe-lg-0': noSeeAllBtnNoAds && i % 3 > 0 && i > 1 && i === slicedRatings.length - 1,
            'pe-md-1 pe-lg-0': noSeeAllBtnNoAds && i % 3 > 0 && i > 1 && i !== slicedRatings.length - 1,
            'ps-lg-1': noSeeAllBtnNoAds && (i + 1) % 3 === 0,
          })}
          style={{ maxWidth: '542px' }}
        >
          <RankingsVehicleCard
            showRank={showRank}
            showEvData={isEvData}
            vehicle={segmentRating}
            onSelectCar={onSelectCar}
            selected={!!selectedCars.find(({ id: carId }) => carId === baseStyleId)}
            selectedCarsNumber={selectedCars.length}
            subtypeId={parseInt(subtypeId, 10)}
            isRatedList={isRatedList}
            isReplaceImage
            type={type}
            dataTrackingParent={dataTrackingParent}
          />
        </Col>
      );
    }
    return acc;
  }, []);

  const defaultAdUnitWrapper = (
    <div
      className={classnames('d-inline-block ms-auto mx-auto', {
        'mt-3_5 mt-lg-1 me-xl-2_5 me-lg-0': !isAds12484Enabled || index > 0,
        'mt-3_5 ads-12484-segment-ad-wrapper mt-lg-0 px-lg-0': isAds12484Enabled && index === 0 && !isSingleCategory,
        'mt-0 mb-1 ads-12484-segment-ad-wrapper mb-lg-0 px-lg-0': isAds12484Enabled && index === 0 && isSingleCategory,
        'ms-lg-1': isAds12484Enabled && index === 0 && smallCards.length > 0,
        'ms-lg-0': isAds12484Enabled && index === 0 && smallCards.length === 0,
      })}
      style={isAds12484MrectStyle}
    >
      {getAdUnit(index, trkParam, isAds12484Enabled, isMobile)}
    </div>
  );

  const mrectIndexLimit = isAds12484Enabled ? 5 : 4;

  return (
    <Fragment>
      {largeCards.map(card => card)}
      {isSubtypePage === false && (
        <Row
          className={classnames('small-cards d-sm-flex mx-md-0', {
            'mb-1': noSeeAllBtnNoAds,
          })}
        >
          {smallCards.map(card => card)}
          {renderSeeAllBtn && renderSeeAllBtn('hidden-lg-up w-100')}
          {!skipRenderAds && index < mrectIndexLimit && defaultAdUnitWrapper}
        </Row>
      )}
      {renderSeeAllBtn && renderSeeAllBtn('hidden-lg-down')}
    </Fragment>
  );
};

export function VehicleSubtypeRankingsList({
  trkParam = {},
  onSelectCar,
  selectedCars,
  selectedCarsNumber = 0,
  subtype,
  isAlwaysOpened = true,
  isMobile = false,
  isHighlights = false,
  isSubtypePage = false,
  isSubtypeExpansionPage = false,
  dataTrackingParent = null,
  index = 0,
  isSingleCategory = false,
  subtypeAdPlacementIndices = null,
  type = null,
  isAds12484Enabled = false,
  ads12491Recipe,
}) {
  const { description, segmentRatings, id, displayName, edmundsTypeCategory } = subtype;
  const withRating = isSubtypePage ? segmentRatings : segmentRatings.slice(0, RANKING_DATA.maxRatedVehiclesNum);
  const hasCollapsedList = withRating.length > RANKING_DATA.DISPLAYED_VEHICLES_NUM && !isAlwaysOpened;
  const isRatedList = !withRating.length || withRating.length >= VEHICLES_NUM_TO_RANK;
  const listId = `${getAnchorName(displayName)}-${id}`;
  const headingId = `${listId}-heading`;

  const vehicleCardListProps = {
    segmentRatings: withRating,
    subtypeId: id,
    isEvData: edmundsTypeCategory.toLowerCase() === 'electric',
    isRatedList,
    index,
    onSelectCar,
    selectedCars,
    selectedCarsNumber,
    isMobile,
    dataTrackingParent,
  };

  function renderSeeAllBtn(classes) {
    const subtypeSubsegmentLink = buildSubtypeSubsegmentLink(edmundsTypeCategory, displayName);
    const displayNameToUse = displayName.toLowerCase().replace('suv', 'SUV');
    return (
      <Fragment>
        {hasCollapsedList && !subtypeSubsegmentLink && (
          <LazyContentCollapseTransitioned
            btnTrackingId="subtype_list"
            textOpen="See fewer"
            textClosed={isMobile ? 'See all' : `See all ${displayNameToUse}`}
            className={classnames('col-12', classes)}
          >
            {getRatedVehicleCardsList({
              ...vehicleCardListProps,
              startPos: RANKING_DATA.DISPLAYED_VEHICLES_NUM,
              isHighlights,
              isCollapseItem: true,
              isSubtypePage,
              skipRenderAds: true,
              type,
              isMobile,
              isAds12484Enabled,
              ads12491Recipe,
            })}
          </LazyContentCollapseTransitioned>
        )}
        {!isSubtypePage && subtypeSubsegmentLink && (
          <div className={classnames('col-12 pt-0_25 pt-md-0_75 text-center', classes)}>
            <EDSButton href={subtypeSubsegmentLink} aria-labelledby={headingId} size="large">
              <span className="fw-medium">
                See all <span className="visually-hidden">{displayNameToUse}</span>
              </span>
            </EDSButton>
          </div>
        )}
      </Fragment>
    );
  }

  const renderDescription = (
    <p className="size-16 text-cool-gray-30 mb-0" style={{ maxWidth: '940px' }}>
      {description}
    </p>
  );
  const descriptionCopy = SUV_EXTRA_HEADING_DATA[displayName.trim().replace(/\s/g, '_').toLowerCase()];

  const renderReadMore = (
    <ReadMore
      containerClasses={classnames('size-16 text-cool-gray-30', {
        'mb-2': isRatedList,
        'mb-0_75': !isRatedList,
      })}
      summaryClasses="pt-0_5 text-blue-40"
      baseDescriptionCopy={renderDescription}
      style={{ maxWidth: '940px' }}
    >
      {descriptionCopy && <div className="pt-1">{descriptionCopy}</div>}
      <ol className="pt-1 list-unstyled w-100">
        {segmentRatings.slice(0, 5).map(({ modelYear, rank, modelDisplayOverride }) => {
          const { modelName, makeName, year } = modelYear;
          const yearMakeModel = `${year} ${makeName} ${modelDisplayOverride || modelName}`;
          return (
            <li key={`${yearMakeModel}`} value={rank}>
              <span className="fw-bold pe-0_5">
                {isRatedList ? <small>#</small> : '•'}
                {isRatedList && rank}
              </span>
              {yearMakeModel}
            </li>
          );
        })}
      </ol>
    </ReadMore>
  );

  const renderH2 = (
    <h2
      id={headingId}
      className="heading-2 d-inline-block mb-0_75 text-cool-gray-20 text-capitalize w-100"
      data-test="subtype-heading"
    >
      {`Best ${displayName}`}
    </h2>
  );

  return (
    <ScrollElement
      id={`${listId}`}
      aria-describedby={headingId}
      className="vehicle-subtype-rankings-list list-unstyled pos-r mb-3_5"
      data-tracking-parent={dataTrackingParent}
    >
      {!isSubtypeExpansionPage && (
        <Row className="subtype-heading justify-content-between">
          <Col xs={12} md={'auto'} className="size-24 pt-1 pt-md-0 mb-0_5">
            {renderH2}
            {renderReadMore}
          </Col>
        </Row>
      )}
      {!isRatedList && (
        <div className="px-1 py-0_5 mb-1 text-gray-darker medium rounded">
          <i className="not-enough-icon icon-info size-16 me-0_5" aria-hidden />
          Not enough vehicles yet to rank
        </div>
      )}
      {getRatedVehicleCardsList({
        ...vehicleCardListProps,
        startPos: 0,
        // rendering all cards if no collapsed list
        endPos: hasCollapsedList ? RANKING_DATA.DISPLAYED_VEHICLES_NUM : undefined,
        renderSeeAllBtn: isSingleCategory ? undefined : renderSeeAllBtn,
        isSubtypePage,
        subtypeAdPlacementIndices,
        trkParam,
        type,
        isSubtypeExpansionPage,
        isSingleCategory,
        isAds12484Enabled,
        ads12491Recipe,
      })}
      {
        /** EDGE CASE:
         * Only for parent type page with only one category, such as the minivan page,
         * who does not have a subtype page:
         * Show all the remainder of the small cards on the parent page
         */
        isSingleCategory &&
          !isSubtypePage &&
          getRatedVehicleCardsList({
            ...vehicleCardListProps,
            startPos: RANKING_DATA.DISPLAYED_VEHICLES_NUM,
            isHighlights,
            isCollapseItem: true,
            isSubtypePage: false,
            skipRenderAds: true,
            type,
            isSingleCategory,
            isAds12484Enabled,
            ads12491Recipe,
          })
      }
    </ScrollElement>
  );
}

VehicleSubtypeRankingsList.propTypes = {
  subtype: TypeRankingsEntities.VehicleRanking.isRequired,
  onSelectCar: PropTypes.func.isRequired,
  selectedCars: PropTypes.arrayOf(PropTypes.object).isRequired,
  selectedCarsNumber: PropTypes.number,
  isAlwaysOpened: PropTypes.bool,
  dataTrackingParent: PropTypes.string,
  isMobile: PropTypes.bool,
  isHighlights: PropTypes.bool,
  isSubtypePage: PropTypes.bool,
  isSubtypeExpansionPage: PropTypes.bool,
  index: PropTypes.number,
  trkParam: PropTypes.shape({
    trk: PropTypes.string,
  }),
  isSingleCategory: PropTypes.bool,
  subtypeAdPlacementIndices: PropTypes.arrayOf(PropTypes.shape({})),
  type: PropTypes.string,
  ads12491Recipe: PropTypes.string,
};
